import { useTranslation } from "react-i18next";
import {
  useAddAdministratorMutation,
  useAdministratorsQuery,
  useRemoveAdministratorMutation,
} from "../Teams.state";
import { useUserQuery } from "../../monitor/User.state";
import { CardBody } from "../../App.styles";
import TeamSelect from "../TeamSelect";
import Spinner from "../../common/Spinner";

const Administrators = () => {
  const { t } = useTranslation();
  const { data: administrators, isFetching } = useAdministratorsQuery();
  const { addAdministrator } = useAddAdministratorMutation();
  const { removeAdministrator } = useRemoveAdministratorMutation();
  const user = useUserQuery();

  const handleChange = async (value) => {
    for (let player of value.filter(
      (v) => !administrators.find((a) => a.id === v.id)
    )) {
      await addAdministrator(player);
    }

    for (let player of administrators.filter(
      (a) => !value.find((v) => a.id === v.id)
    )) {
      await removeAdministrator(player);
    }
  };

  return (
    <CardBody className="card">
      <div className="card-header bg-dark text-light">
        <span className="card-title">{t('Administrators')}</span>
      </div>
      <div className="card-body">
        <p dangerouslySetInnerHTML={{__html: t(`Want someone else to help manage? Add them here to give them full
          access.`)}} />
          {
            isFetching
            ? <Spinner size="0.875rem" />
            : (
              <TeamSelect
                setValue={handleChange}
                value={
                  user.game.creator && !administrators.find((a) => a.id === user.id)
                    ? administrators.concat(user)
                    : administrators
                }
                mapLabel="email"
                placeholder={t("Select people...")}
              />
            )
          }
      </div>
    </CardBody>
  );
};

export default Administrators;
